export function calculateInvoiceFees(
  sellingPrice: number,
  feePercent: number,
): number {
  if (!sellingPrice || !feePercent) return 0;
  return Math.round(((sellingPrice * feePercent) / 100) * 1e2) / 1e2;
}
